import { SxProps, Theme, Typography } from '@mui/material';

// This plays an important role in keeping all of the content with the slide. If you change this,
// make sure to validate the layout of all of the different slides.
export const VERTICAL_SPACING = 5;

interface EducationalSlideHeaderProps {
  children: React.ReactNode;
  color?: string;
  sx?: SxProps<Theme>;
}

export function EducationalSlideH1({
  children,
  color,
}: EducationalSlideHeaderProps) {
  return (
    <Typography
      variant="h1_display"
      sx={(t) => ({
        color: color ?? t.palette.primary.main,
        fontSize: '3rem',
        lineHeight: 1.1,
      })}
    >
      {children}
    </Typography>
  );
}

export function EducationalSlideH2({
  children,
  color,
}: EducationalSlideHeaderProps) {
  return (
    <Typography
      variant="h2_display"
      sx={(t) => ({
        color: color ?? t.palette.primary.main,
        fontSize: '2rem',
        lineHeight: 1.1,
      })}
    >
      {children}
    </Typography>
  );
}

export function EducationalSlideH3({
  children,
  color,
}: EducationalSlideHeaderProps) {
  return (
    <Typography
      variant="h2_display"
      component="h3"
      sx={(t) => ({
        color: color ?? t.palette.primary.main,
        fontSize: '1.5rem',
        lineHeight: 1.2,
      })}
    >
      {children}
    </Typography>
  );
}

export function EducationalSlideH4({
  children,
  color,
}: EducationalSlideHeaderProps) {
  return (
    <Typography
      variant="h2_display"
      component="h4"
      sx={(t) => ({
        color: color ?? t.palette.primary.main,
        fontSize: '1.25rem',
        lineHeight: 1.2,
      })}
    >
      {children}
    </Typography>
  );
}

export function EducationalSlideBody({
  children,
}: React.PropsWithChildren<unknown>) {
  return <Typography variant="body-s">{children}</Typography>;
}
